import { useQuery } from '@tanstack/react-query';
import { SheetFeatureApi } from 'api/sheet/sheet-feature-api';
import { useAccountDataQuery } from 'queries/account';

export const useSheetsFeature = () => {
  const { data } = useAccountDataQuery();
  const isSheetsEnabled = useQuery({
    queryKey: ['isSheetsEnabled'],
    queryFn: () =>
      data?.account?.accountId
        ? SheetFeatureApi.isSheetsEnabled(data?.account?.accountId)
        : Promise.resolve({ enabled: false }),
  });

  return !!isSheetsEnabled.data?.enabled;
};
